import * as types from "./types";

const initialState = {
  rows: [],
  loading: false,
  error: null,
};

export default function limitReducer(state = initialState, action) {
  switch (action.type) {

    case types.GET_SITE:
      return {
        ...state,
        site: action.payload,
      };

    case types.ADD_SITE:
      return {
        ...state,
        added_site: action.payload,
      };

    case types.UPDATE_SITE:
      return {
        ...state,
        update_site: action.payload,
      };

    case types.DELETE_SITE:
      return {
        ...state,
        delete_site: action.payload,
      };

    case types.APPROVE_SITE:
      return {
        ...state,
        approving: action.payload,
      };

    default:
      return state;
  }
}
